module.exports = __webpack_public_path__ + "img/team-icon.4ba295b8.png";